import { useQuery } from '@apollo/react-hooks';
import { TrackEvent } from '@bnnvara/analytics';
import { useBrand } from '@bnnvara/brand';
import PropTypes from 'prop-types';
import React from 'react';

import { FetchPlayerMedia } from '../../api/queries/player.gql';
import broadcasterLogoSelector from '../../helpers/broadcasterLogoSelector';
import resizeImageSource, {
  resizeImageSourceMax,
} from '../../helpers/resizeImageSource';
import FollowBrand from '../FollowBrand';
import Link from '../Link';
import Header from './Header';

export const extractTitlesFromTagLine = (tagline) => {
  const titles = tagline ? tagline.split('|') : [];
  const trimmedTitles = titles.map((text) => text.trim());
  return trimmedTitles;
};

const defaultAtInternetId = 70;

const BrandHeader = ({ titleElement }) => {
  const brand = useBrand();

  const mobileImage =
    brand.backgroundImageMobileUrl || brand.backgroundImageUrl;

  const [subtitle, secondSubtitle] = extractTitlesFromTagLine(brand.tagline);

  /**
   * Get video for in background header
   */
  const skipFetchPlayerMedia = !brand.backgroundVideoId;
  const { loading, error, data } = useQuery(FetchPlayerMedia, {
    variables: {
      id: brand.backgroundVideoId,
      hasAdConsent: false,
      atInternetId: defaultAtInternetId,
    },
    skip: skipFetchPlayerMedia,
  });
  const bgVideoTeaserData =
    loading || error ? null : { ...data?.player?.sources };

  return (
    <Header
      title={brand.name}
      titleElement={titleElement}
      subtitle={subtitle && subtitle}
      description={brand.description}
      broadcaster={brand.broadcasters && brand.broadcasters[0]}
      broadcasterLogo={
        brand.broadcasters && broadcasterLogoSelector(brand.broadcasters[0])
      }
      secondSubtitle={secondSubtitle && secondSubtitle}
      secondBroadcaster={brand.broadcaster && brand.broadcaster[1]}
      secondBroadcasterLogo={
        brand.broadcasters && broadcasterLogoSelector(brand.broadcasters[1])
      }
      LinkComponent={Link}
      linkComponentProps={{
        href: {
          pathname: '/[brandSlug]',
          query: {
            brandSlug: brand.slug,
          },
        },
      }}
      FollowBrand={FollowBrand}
      image={resizeImageSourceMax(brand.backgroundImageUrl)}
      mobileImage={resizeImageSource(mobileImage, 480)}
      bgVideoTeaser={bgVideoTeaserData && bgVideoTeaserData[0]}
      brandLogo={resizeImageSource(brand.logoUrl, 120)}
      color="white"
      buttonText={brand.callToAction && brand.callToAction.text}
      buttonUrl={brand.callToAction && brand.callToAction.url}
      buttonOnClick={() => {
        TrackEvent('header', 'click', 'cta');
      }}
      socialText="VOLG ONS"
      facebook={brand.facebook}
      instagram={brand.instagram}
      twitter={brand.twitter}
      youtube={brand.youtube}
    />
  );
};

BrandHeader.propTypes = {
  titleElement: PropTypes.string,
};

export default BrandHeader;
